import styled, { css } from 'styled-components';
import Box from '../../../../_shared/components/Box';
import { ListVariant } from '../../../../_shared/types/trade';

export const footerVariants = {
  [ListVariant.SEARCH]: css`
    display: none;
  `
};

export const StyledWrapper = styled(Box)`
  width: 100%;
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  align-items: center;
`;

export const StyledControls = styled(Box)`
  flex: 0 0 auto;
  display: flex;
  justify-content: space-between;
  ${props => footerVariants[props.variant]};
`;
